// @flow
import React from "react";
import { isNil } from "ramda";
import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoAjusteDias,
  SelecaoDeflacao,
  SelecaoNormalizacao,
  SelecaoCorrecaoMonetaria,
} from "../configuracoes";
import {
  ID_PERIODICIDADE_MENSAL,
  ID_OPCAO_DEFLATOR_NENHUM,
  ID_OPCAO_CORRETOR_MONETARIO_NENHUM,
} from "../../../model";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getExibirConfiguracoesAvancadas,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import { useSelector } from "react-redux";

export const processarPontualMensalDeflatorCorrecao = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);
    const exibirConfiguracoesAvancadas = getExibirConfiguracoesAvancadas(state);

    const configCorrecao =
      exibirConfiguracoesAvancadas &&
      !isNil(edicaoMedida.corretorMonetario) &&
      edicaoMedida.corretorMonetario !== ID_OPCAO_CORRETOR_MONETARIO_NENHUM
        ? {
            correcaoMonetaria: edicaoMedida.corretorMonetario,
          }
        : {};
    const configDeflator =
      exibirConfiguracoesAvancadas &&
      !isNil(edicaoMedida.deflator) &&
      edicaoMedida.deflator !== ID_OPCAO_DEFLATOR_NENHUM
        ? {
            deflator: edicaoMedida.deflator,
          }
        : {};
    const configValorDataBase =
      exibirConfiguracoesAvancadas &&
      !isNil(edicaoMedida.valorBaseDeflator) &&
      !isNil(edicaoMedida.dataBaseDeflator)
        ? {
            valorBaseDeflator: edicaoMedida.valorBaseDeflator,
            valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
            dataBaseDeflator: edicaoMedida.dataBaseDeflator,
            dataBaseDeflatorDataEspecifica:
              edicaoMedida.dataBaseDeflatorDataEspecifica,
          }
        : {};

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        ...configCorrecao,
        ...configDeflator,
        ...configValorDataBase,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: ID_PERIODICIDADE_MENSAL,
        ajusteDias: edicaoMedida.ajusteDias,
        dataBase: dataBase,
        ...configCorrecao,
        ...configDeflator,
        ...configValorDataBase,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PontualMensalDeflatorCorrecao = () => {
  const modoSeries = useSelector(isModoSeries);

  return (
    <div>
      <div className="ConfiguracaoMedida--row">
        <SelecaoPeriodo exibirPeriodicidade={false} />
        <div className="ConfiguracaoMedida__group">
          <div className="ConfiguracaoMedida__box">
            <SelecaoAjusteDias />
          </div>
        </div>

        {!modoSeries && <SelecaoCasasDecimais />}
      </div>

      <div className="ConfiguracaoMedida--row">
        <div className="ConfiguracaoMedida__group">
          <div className="ConfiguracaoMedida__box">
            <SelecaoDeflacao exibirNormalizacao={false} />
          </div>
        </div>
        <div className="ConfiguracaoMedida__group">
          <div className="ConfiguracaoMedida__box">
            <SelecaoCorrecaoMonetaria />
          </div>
        </div>
        <div className="ConfiguracaoMedida__group">
          <div className="ConfiguracaoMedida__box">
            <SelecaoNormalizacao
              forcarExibirNormalizacao={true}
              exibirOpcaoNenhum={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PontualMensalDeflatorCorrecao;
